import React, { ReactNode, useEffect, useRef } from "react";
import ReactDOM from "react-dom";

interface PortalProps {
  children: ReactNode;
}

const Portal: React.FC<PortalProps> = ({ children }) => {
  const portalRef = useRef<HTMLDivElement>(document.createElement("div"));

  useEffect(() => {
    const portalElement = portalRef.current;
    document.body.appendChild(portalElement);

    return () => {
      document.body.removeChild(portalElement);
    };
  }, []);

  return ReactDOM.createPortal(children, portalRef.current);
};

export default Portal;
